module.exports = __webpack_public_path__ + "img/sceneIcon4-2.00e1ad7f.png";